module.exports = __webpack_public_path__ + "static/makeLove-5926d9742c8ab5637bc8fdd1c7bbce4e.jpg";